import { api } from './backend';

//export const update = (data) => api.patch('/front/professionals/', data);
export const post = (data) => api.post('front/professional-plans/', data);

export const get = () => api.get('front/professional-plans/');

export const getById = (id) => api.get(`front/ratings?page=1&limit=100&professional_id=${id}`);

export const remove = (id)=> api.delete(`/front/professional-plans/${id}`);